import { render } from "./ProductAggregation.vue?vue&type=template&id=ab6d8034&scoped=true"
import script from "./ProductAggregation.vue?vue&type=script&lang=js"
export * from "./ProductAggregation.vue?vue&type=script&lang=js"

import "./ProductAggregation.vue?vue&type=style&index=0&id=ab6d8034&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab6d8034"]])

export default __exports__